import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { mountPoconoConfig } from "./data";

export default function MountPoconoPage() {
  return <CityPageTemplate config={mountPoconoConfig} />;
}